

function SimpleLoading() {
    return(
        <div className="text-[10rem] bg-black text-white">Loading...</div>
    )
}

export default SimpleLoading;